import { StringType } from '@convergence/types';
import { getError, valueFromTreeAndPath } from '../util';
import { AnalysisInputProps } from '../types';

export function AnalysisStringInput(props: AnalysisInputProps<StringType>) {
  let value =
    valueFromTreeAndPath<string>(props.tree, props.propertyPath) ?? '';

  const error = getError(props.errors, props.propertyPath);

  return (
    <div className="py-2">
      <label className="inline-flex items-center">
        {props.name}
        <input
          type="text"
          placeholder={props.value._optional ? 'Optional' : ''}
          className="ml-2 border rounded px-1"
          onChange={(e) => {
            console.log({ path: props.propertyPath, value: e.target.value });
            props.onChange(props.propertyPath, e.target.value);
          }}
          value={value}
        />
        {error && <p className="text-red-600">{error.message}</p>}
      </label>
    </div>
  );
}
